var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 14.25H35.25V9C35.25 8.00544 34.8549 7.05161 34.1516 6.34835C33.4484 5.64509 32.4946 5.25 31.5 5.25H7.5C6.50544 5.25 5.55161 5.64509 4.84835 6.34835C4.14509 7.05161 3.75 8.00544 3.75 9V33C3.75019 33.4246 3.87054 33.8405 4.09713 34.1997C4.32373 34.5588 4.64732 34.8465 5.03051 35.0294C5.4137 35.2124 5.84085 35.2832 6.26258 35.2336C6.68431 35.1841 7.08341 35.0162 7.41375 34.7494L12.75 30.4369V34.5C12.75 35.4946 13.1451 36.4484 13.8483 37.1516C14.5516 37.8549 15.5054 38.25 16.5 38.25H33.7819L40.5863 43.7494C40.9166 44.0162 41.3157 44.1841 41.7374 44.2336C42.1592 44.2832 42.5863 44.2124 42.9695 44.0294C43.3527 43.8465 43.6763 43.5588 43.9029 43.1997C44.1295 42.8405 44.2498 42.4246 44.25 42V18C44.25 17.0054 43.8549 16.0516 43.1516 15.3483C42.4484 14.6451 41.4946 14.25 40.5 14.25ZM8.25 28.2881V9.75H30.75V24.75H13.4213C12.904 24.7486 12.4021 24.9254 12 25.2506L8.25 28.2881ZM39.75 37.2881L36 34.2506C35.5999 33.927 35.1009 33.7503 34.5863 33.75H17.25V29.25H31.5C32.4946 29.25 33.4484 28.8549 34.1516 28.1516C34.8549 27.4484 35.25 26.4946 35.25 25.5V18.75H39.75V37.2881Z",
    fill: "#012448",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChats);
export default __webpack_public_path__ + "static/media/Chats.a4562ed0c9d942ee83ada06a37359924.svg";
export { ForwardRef as ReactComponent };